import _regeneratorRuntime from "babel-runtime/regenerator";
import _asyncToGenerator from "babel-runtime/helpers/asyncToGenerator";


import * as utils from "@/tools/util";
import bizPublicSaveMethod from "@/business/businessTools/bizPublicSaveMethod.js";
import tools from "../../QS420/QS420_tools";

var GROUP_ID = "";

var MODULE_ID = "";

var SAVE_PATH = "";

var backfillOldData = function backfillOldData(_this) {
  var controlModuleInfo = _this.oppBusiData.oldBusiData.controlModuleInfo;
  if (!_.isEmpty(controlModuleInfo)) {
    _this.$blMethod.parseGroupsMouduleData(_this, [MODULE_ID], controlModuleInfo);
  }
};

var backfillHistoryData = function backfillHistoryData(_this) {
  var controlModuleInfo = _.cloneDeepGet(_this.historyData, SAVE_PATH);
  if (controlModuleInfo && controlModuleInfo["CONTROLLER_ID_CODE"] && controlModuleInfo["CONTROLLER"]) {
    controlModuleInfo["CONTROLER_ID_NO"] = controlModuleInfo["CONTROLER_ID_CODE"];
    controlModuleInfo["CONTROLER_ID_NO_DATA_SOURCE"] = controlModuleInfo["CONTROLER_ID_CODE_DATA_SOURCE"];

    controlModuleInfo["CONTROLER_NAME"] = controlModuleInfo["CONTROLER"];
    controlModuleInfo["CONTROLER_NAME_DATA_SOURCE"] = controlModuleInfo["CONTROLER_DATA_SOURCE"];
  }
  if (!_.isEmpty(controlModuleInfo)) {
    _this.$blMethod.parseMoudleArray(_this, _this.groupDatas[GROUP_ID][MODULE_ID], controlModuleInfo);
  }
  _.each(_this.groupDatas[GROUP_ID][MODULE_ID], function (item, index) {
    item.FIELDS.IS_SAME_LEGAL_REP.FIELD_CONTROL = "0";
    if (index > 0) {
      item.FIELDS.IS_SAME_LEGAL_REP.FIELD_CONTROL = "1";
    }
  });
};

var initFieldConfig = function initFieldConfig(_this) {
  var fields = _this.groupDatas[GROUP_ID][MODULE_ID][0].FIELDS;
  fields.IS_SAME_LEGAL_REP.FIELD_TYPE = "radio";
  fields.IS_SAME_LEGAL_REP.FIELD_CONTROL = "1";
  var tplFields = _this.groupDatasTpl[GROUP_ID][MODULE_ID][0].FIELDS;
  tplFields.IS_SAME_LEGAL_REP.FIELD_TYPE = "radio";
  tplFields.IS_SAME_LEGAL_REP.FIELD_CONTROL = "1";
  fields.CONTROLER_ID_TYPE.FIELD_DICT_NAME = _.filter(fields.CONTROLER_ID_TYPE.FIELD_DICT_NAME, function (item) {
    return _this.oppBusiData.EFFECT_ID_TYPE.includes(item.DICT_ITEM) && item.DICT_ITEM[0] == "0";
  });

  tplFields.CONTROLER_ID_TYPE.FIELD_DICT_NAME = _.filter(tplFields.CONTROLER_ID_TYPE.FIELD_DICT_NAME, function (item) {
    return _this.oppBusiData.EFFECT_ID_TYPE.includes(item.DICT_ITEM) && item.DICT_ITEM[0] == "0";
  });
};

var update = function update(_this) {
  var module = _this.groupDatas[GROUP_ID][MODULE_ID][0];
  var fields = _this.groupDatas[GROUP_ID][MODULE_ID][0].FIELDS;

  var _loop = function _loop(key) {
    var funcArr = _.get(fields[key], "FIELD_FUNCTION", "").split("|");
    _.each(funcArr || [], function (func) {
      NODE[func] && NODE[func](_this, fields[key], fields, module);
    });
  };

  for (var key in fields) {
    _loop(key);
  }
};

var NODE = {
  getGroupId: function getGroupId() {
    return GROUP_ID;
  },

  getModuleId: function getModuleId() {
    return MODULE_ID;
  },

  init: function init(_this) {
    var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

    GROUP_ID = params.groupId;
    MODULE_ID = params.moduleId;
    SAVE_PATH = params.savePath;
  },

  beforeLoadBiz: function beforeLoadBiz(_this) {

    initFieldConfig(_this);

    if (_this.$storage.getJsonSession(_this.$definecfg.IS_OPEN_ACCT_BIZ) == 0) {
      backfillOldData(_this);
    }
  },

  afterLoadBiz: function afterLoadBiz(_this) {
    backfillHistoryData(_this);
    update(_this);
  },

  beforeSave: function () {
    var _ref = _asyncToGenerator(_regeneratorRuntime.mark(function _callee(_this, params) {
      var controlInfo;
      return _regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              controlInfo = bizPublicSaveMethod.getModuleObjctFoyKey(_this, MODULE_ID, [SAVE_PATH], true);

              if (!_.isArray(controlInfo)) {
                controlInfo = [controlInfo];
              }
              _.each(controlInfo, function (item) {
                item["CONTROLER_ID_CODE"] = item["CONTROLER_ID_NO"];
                item["CONTROLER"] = item["CONTROLER_NAME"];
                item.CONTROLER_EMAIL = "";
                item.POLICE_FLAG = "0";
                item.POLICE_CHECK_SNO = "";
                item.POLICE_VALID_RESULT = "";
                item.POLICE_UNCHECK_REASON = "";
                item.POLICE_OTHER_UNCHECK_REASON = "";
                item.BENEFICIARY_RELA = "";
              });

              bizPublicSaveMethod.getModuleUpdateFlagByPaths(_this, [SAVE_PATH], controlInfo);

              _.set(params, SAVE_PATH, controlInfo);

            case 5:
            case "end":
              return _context.stop();
          }
        }
      }, _callee, this);
    }));

    function beforeSave(_x2, _x3) {
      return _ref.apply(this, arguments);
    }

    return beforeSave;
  }(),

  pageActivated: function pageActivated(_this, groupId) {},
  afterSave: function afterSave(_this, newData) {},
  beforeSkipBiz: function beforeSkipBiz(_this) {},
  update: update
};

export default NODE;


//////////////////
// WEBPACK FOOTER
// ./src/business/businessFile/QS421/bizPro/bizProActualControllerInfo.js
// module id = 212
// module chunks = 2